<template lang="pug">
transition(name="modal")
  .modal-wrapper
    .modal-container.error-modal
      button.close(type="button" aria-label="Close")
        span(aria-hidden="true" @click="$emit('closeError')") &times;
      .row
        h1 Error {{ errorSel.device.name }} {{errorSel.createdAt | formatDateTime}}
        table.table.table-condensed.table-hover
          tbody
            tr
              th id
              td {{errorSel.id}}
            tr
              th {{$options.filters.translate('Result', lang)}}
              td {{errorSel.body}}
            tr
              th {{$options.filters.translate('Date', lang)}}
              td {{errorSel.createdAt | formatDateTime}}
            tr
              th {{$options.filters.translate('Code', lang)}}
              td {{matrix.code}}
            tr
              th {{$options.filters.translate('Place', lang)}}
              td {{matrix.area}}
            tr
              th {{$options.filters.translate('Object', lang)}}
              td {{matrix.object}}
            tr
              th {{$options.filters.translate('Error', lang)}}
              td {{matrix.error}}
            tr
              th {{$options.filters.translate('Description', lang)}}
              td {{matrix.description}}
            tr
              th R
              td {{matrix.R}}
            tr
              th I
              td {{matrix.I}}
            tr
              th {{$options.filters.translate('Level', lang)}}
              td {{matrix.level}}
</template>

<script>
export default {
  name: 'error-display',
  props: ['lang', 'errorSel', 'matrix'],
  data () {
    return {
    }
  },
  methods: {
    escapeModal (e) {
      if (e.key === 'Escape') {
        this.$emit('closeError')
      }
    }
  },
  created () {
    window.addEventListener('keyup', this.escapeModal, false)
  },
  beforeDestroy () {
    window.removeEventListener('keyup', this.escapeModal, false)
  }
}
</script>
<style lang="sass" scoped>
th
  white-space: nowrap

.error-modal
  position: fixed
  z-index: 999
  margin-top: -20px !important
  margin-left: -20px !important
</style>



// WEBPACK FOOTER //
// src/components/errors/Error.vue